import Vue from "vue";
import Buefy from "buefy";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PageTitle from "./components/PageTitle.vue";
import Page from "./components/Page.vue";
import Form from "./components/Form.vue";
import DatePicker from "./components/DatePicker.vue";
import AppLoading from "./components/AppLoading.vue";
import AppModal from "./components/AppModal.vue";
import AppButton from "./components/AppButton.vue";
import AppForm from "./components/AppForm.vue";
import AppFormField from "./components/AppFormField.vue";
import AppFormError from "./components/AppFormError.vue";
import AppSortableTable from "./components/AppSortableTable.vue";
import FormField from "@/components/FormField.vue";
import With from "@/components/With.vue";
import PreviewButton from "@/components/PreviewButton.vue";
import Formatter from "./plugins/Formatter";
// import LoadScript from "vue-plugin-load-script";

import "@mdi/font/css/materialdesignicons.css";
import "marked";
import WindowTitle from "./plugins/WindowTitle";
import HeaderProcess from "./plugins/HeaderProcess";
import VueGtag from "vue-gtag";
import _ from "lodash";
import JwtToken from "./api/JwtToken";
import DefaultLayout from "./components/Layout/DefaultLayout.vue";
import FullPageLayout from "./components/Layout/FullPageLayout.vue";
// import { ApolloClient } from 'apollo-client';
// import { HttpLink } from "apollo-link-http";
// import { InMemoryCache } from 'apollo-cache-inmemory';
// import VueApollo, { ApolloProvider } from 'vue-apollo';

Vue.config.productionTip = false;

// Vue.use(LoadScript);
Vue.mixin({
  computed: {
    _: () => _
  }
});
Vue.mixin(WindowTitle);
Vue.mixin(HeaderProcess);
Vue.use(Formatter);
Vue.use(Buefy, {
  defaultDayNames: ["日", "月", "火", "水", "木", "金", "土"],
  defaultMonthNames: Array(12)
    .fill(0)
    .map((v, i) => i + 1 + "月")
});
Vue.use(
  VueGtag,
  {
    config: { id: "G-WPXG5CSPEP" },
    includes: [{ id: "UA-124903503-2" }]
  },
  router
);
Vue.component("PageTitle", PageTitle);
Vue.component("Page", Page);
Vue.component("Form", Form);
Vue.component("DatePicker", DatePicker);
Vue.component("AppModal", AppModal);
Vue.component("AppButton", AppButton);
Vue.component("AppForm", AppForm);
Vue.component("AppFormField", AppFormField);
Vue.component("AppFormError", AppFormError);
Vue.component("AppLoading", AppLoading);
Vue.component("AppSortableTable", AppSortableTable);
Vue.component("FormField", FormField);
Vue.component("PreviewButton", PreviewButton);
Vue.component("With", With);
Vue.component("DefaultLayout", DefaultLayout);
Vue.component("FullPageLayout", FullPageLayout);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
